module.exports = __webpack_public_path__ + "fonts/gothic-a1-v8-latin-700.81ace063.woff";